<template>
  <div class="body">
    <el-container>
      <!-- <ProductsAside /> -->
      <el-main>
        <div class="bg-White p-3 mt-2">
          <el-row :gutter="10">
            <el-col :xl="8" :lg="8" :md="8" :sm="12">
              <SearchProducts
                :allowCreateNewProduct="false"
                :showStockZero="true"
                ref="searchProductsComponent"
                :supplier="supplier"
                @selectedProduct="getSelectedProduct"
              />
            </el-col>
            <el-col :xl="8" :lg="8" :md="8" :sm="12">
              <div class="block">
                <!-- <span class="demonstration">Default</span> -->
                <el-date-picker
                  @change="getProductReport"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                  style="max-width: 100% !important"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col
              class="mt-lg-2"
              style="text-align: left"
              :xl="8"
              :lg="8"
              :md="6"
              :sm="12"
              v-if="product"
            >
              <!-- <el-button class="" type="warning" @click="getProductReport()">
                التقرير</el-button
              > -->
              <el-button
                type="success"
                title="طباعه"
                icon="el-icon-printer"
                @click="sendToPrintAll(tableData)"
              ></el-button>
              <el-button
                class="mr-2"
                type="danger"
                @click="showUpdateStock = true"
                v-if="!showUpdateStock"
              >
                تسوية الرصيد</el-button
              >
              <el-form
                :inline="true"
                :model="selectedProduct"
                v-if="showUpdateStock"
              >
                <el-form-item>
                  <el-input
                    placeholder="الرصيد الفعلي"
                    v-model="selectedProduct.available"
                    autocomplete="off"
                    type="number"
                    @focus="$event.target.select()"
                  ></el-input>
                </el-form-item>
                <el-button class="" type="danger" @click="updateStock">
                  تعديل الرصيد</el-button
                >
              </el-form>
            </el-col>
          </el-row>
        </div>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column sortable width="440" label="البيان" prop="note">
          </el-table-column>
          <el-table-column label="الكمية">
            <template slot-scope="scope">
              <span v-if="scope.row.unit_type == 1">{{
                scope.row.qty / scope.row.units_per_package
              }}</span>
              <span v-else>{{ scope.row.qty }}</span>
            </template>
          </el-table-column>
          <el-table-column label="الوحدة" prop="unit"> </el-table-column>
          <!-- <el-table-column sortable width="100" label="الفرعية">
            <template slot-scope="scope">
              <span>{{ scope.row.balance / scope.row.units_per_package }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="الرصيد" prop="balance">
            <!-- <template slot-scope="scope">
              {{numberToFixed(scope.row.balance)}}
            </template> -->
          </el-table-column>
          <el-table-column label="بواسطة" prop="user.name"> </el-table-column>
          <el-table-column
            width="170"
            sortable
            label="التوقيت"
            prop="created_at"
          >
          <template slot-scope="scope">
            {{scope.row.created_at | moment("Do / MM / YYYY | h:mm A")}}
          </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ProductsAside from "@/components/ProductsAside.vue";
import SearchProducts from "@/components/Products/SearchWithLastBuyPrice";
// import { ipcRenderer } from "electron";

export default {
  name: "Products",

  components: {  SearchProducts },

  data() {
    return {
      showUpdateStock: false,
      supplier: {
        id: 1,
        name: "default",
      },
      true: true,
      productsLength: 0,
      dateRange: null,
      editFormVisible: false,
      tableData: [],
      selectedProduct: {
        qty: null,
        available: null,
      },
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      current_page: 1,
      page_limit: 1,
    };
  },
  created() {},
  methods: {
    getSelectedProduct(e) {
      this.product = e.product;
      this.$refs.searchProductsComponent.setValue(this.product);
      this.selectedProduct.min_threshold = this.product.inventories[0].pivot.min_threshold;
      this.selectedProduct.available = "";
      this.getProductReport();
    },
    updateStock() {
      // products-stock/{id}
      if (this.selectedProduct.available != "") {
        const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });
        axiosApi
          .post(`products-stock/${this.product.id}`, this.selectedProduct)
          .then(() => {
            this.getProductReport();
            this.showUpdateStock = false;
            this.$notify({
              title: "تمت العملية بنجاح",
              message: "تم تسوية رصيد المنتج بنجاح",
              type: "success",
              duration: 1500,
            });
          })
          .catch((e) => {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات المطلوبة",
              duration: 1500,
            });
            console.log(e);
          })
          .finally(() => loading.close());
      } else {
        this.$notify.error({
          title: "حدث خطأ",
          message: "عفوا تأكد من تحديد المخزون الفعلي لاتمام التسوية ",
          duration: 1500,
        });
      }
    },
    sendToPrintAll(){
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   dateRange:this.dateRange,
      //   type: "ProductMovement",
      //   title: " حركة منتج " + this.product.name
      // };
      // ipcRenderer.send("printing", data);
    },
    getProductReport() {
      if (this.product) {
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل البيانات",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let url = `products/interval-report/${this.product.id}/1`;
        if (this.dateRange != null) {
          url += `?start_date=${this.dateRange[0]}`;
          url += `&end_date=${this.dateRange[1]}`;
        }
        axiosApi
          .get(url)
          .then((response) => {
            this.oldStock = response.data.oldStock;
            this.tableData = response.data.history;
            let sum = response.data.oldStock / this.product.units_per_package;
            this.tableData.map(function (value) {
              if (value["type"] > 0) {
                sum += Number(value["qty"]) / Number(value["units_per_package"]);
                // if(value['unit_type']==2){
                // }
                // else{
                //   sum += value["qty"]/value['units_per_package'];
                // }
              } else {
                sum -= Number(value["qty"]) / Number(value["units_per_package"]);
                //   if(value['unit_type']==2){
                // }else{
                //   sum -= value["qty"]/value['units_per_package'];
                // }
              }
              value["balance"] = sum;
            });
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    update() {
     const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .put(`products/${this.selectedProduct.id}`, this.selectedProduct)
        .then(() => {
          this.getProductReport();
          this.editFormVisible = false;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم تحديث بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
    },
    getCategories() {
      axiosApi
        .get("product-categories")
        .then((res) => {
          this.productCategories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 88%;
  overflow-y: scroll;
}
</style>
